import script from "./ReembolsoForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ReembolsoForm.vue?vue&type=script&setup=true&lang=js"

import "./ReembolsoForm.vue?vue&type=style&index=0&id=48d65fac&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48d65fac"]])

export default __exports__